import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthLayoutComponent } from './pages/auth-layout/auth-layout.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { PublicCertificateComponent } from './pages/public-certificate/public-certificate.component';
import { PublicMultiCertificateComponent } from './pages/public-multi-certificate/public-multi-certificate.component';

import { AuthGuard } from '@core/guards/auth/auth.guard';
import { RoleGuard } from '@core/guards/role/role.guard';

import {
  USERS_PATH_ROLES,
  CERTIFICATES_PATH_ROLES,
  TASKS_PATH_ROLES,
  M_CERTIFICATES_PATH_ROLES
} from './modules/shared/consts/roles';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'not-found', component: NotFoundPageComponent },
  { path: 'public-certificate/:id', component: PublicCertificateComponent },
  {
    path: 'public-multi-certificate/:id',
    component: PublicMultiCertificateComponent
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'users',
        canActivate: [RoleGuard],
        data: { allowedRoles: USERS_PATH_ROLES },
        loadChildren: () =>
          import('./modules/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'certificates',
        canActivate: [RoleGuard],
        data: { allowedRoles: CERTIFICATES_PATH_ROLES },
        loadChildren: () =>
          import('./modules/certificates/certificates.module').then(
            m => m.CertificatesModule
          )
      },
      {
        path: 'multi-certificates',
        canActivate: [RoleGuard],
        data: { allowedRoles: M_CERTIFICATES_PATH_ROLES },
        loadChildren: () =>
          import('./modules/multi-certificates/multi-certificates.module').then(
            m => m.MultiCertificatesModule
          )
      },
      {
        path: 'tasks',
        canActivate: [RoleGuard],
        data: { allowedRoles: TASKS_PATH_ROLES },
        loadChildren: () =>
          import('./modules/tasks/tasks.module').then(m => m.TasksModule)
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  { path: '**', component: NotFoundPageComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
